import React, { useRef, useState } from "react";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { ErrorMessage, useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import CampaignLangs from "./_langs";
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, INTERNATIONAL,
    LB_ACTIVE,
    LB_CODE,
    LB_END_DATE,
    LB_START_DATE,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { TT_HISTORY } from "../../../components/i18n/toolTips";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services
import { campaignService } from "../../../jwt/_services/campaign/campaignService";


const CampaignForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [showModal, setShowModal] = useState(true)
    const [status, setStatus] = useState( domainObject?.status || false)
    const [langs, setlangs] = useState(domainObject?.langs || []);

    const modalRef = useRef(null);




    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            startDate: domainObject?.startDate,
            endDate: domainObject?.endDate,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                status,
                langs
            }
        };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(campaignService, id, dataRequest)
        } else {
            genericActions.save(campaignService, dataRequest)
        }


        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input type="text" name="code"
                                       placeholder={LB_CODE}
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{LB_START_DATE}</Label>
                                <Input type="date"
                                   name="startDate"
                                   placeholder={LB_START_DATE}
                                   innerRef={register}
                                   disabled={disableInputs}
                                   className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="startDate" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{LB_END_DATE}</Label>
                                <Input type="date"
                                       name="endDate"
                                       placeholder={LB_END_DATE}
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="endDate" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label>{LB_ACTIVE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={ status }
                                    disabled={ disableInputs }
                                    onChange={ _ => setStatus(!status) }
                                />

                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <CampaignLangs langs={langs} setLangs={setlangs} />
                    </CardBody>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(CampaignForm)